import {defaultPagination} from "@/services/pagination";
import {
  exportSnapshot,
  listChatBreadcrumps,
  listItems,
  restoreSnapshot
} from "@/services/api/app/office/recovery/exchange/data-set/chat";
import {listInitialBackupStats} from "@/services/api/app/common/initialBackup";

const defaultState = () => ({
  files: [],
  messages: [],
  searchFiles: [],
  searchPagination: {
    ...defaultPagination(),
    sortBy: 'snapshots.chat_message.created_date_time'
  },
  paginationChatUsers: {
    ...defaultPagination(),
    pageSize: 20
  },
  paginationChatMessages: {
    ...defaultPagination(),
    pageSize: 20,
    sortBy: 'snapshots.chat_message.created_date_time',
    sortDescending: true
  },
  folderId: null,
  breadcrumps: null,
  search: null,
  initialSearch: null,
  initialBackupStatus: {},
  filterBackupStatus: {
    provider: 1,
    module: 5,
    dataType: 13,
  },
})

export default {
  namespaced: true,

  actions: {
    listSnapshotChatDetails({commit, state}, data) {

      return listItems({
        ...data,
        pagination: data.pagination,
      })
        .then(({result, pagination}) => {
          let index = Date.parse(new Date());
          const res = result.map(file => {
            return {
              ...file,
              originalId: file.id,
              id: index++
            }
          })

          if (data.type == 'Folder') {
            commit('setFiles', res)
            commit('setPaginationChatUsers', pagination)
          } else if (data.type === 'Message' || data.isMessageForChat) {
            commit('setMessages', res)
            commit('setPaginationChatMessages', pagination)
          }
        })
    },
    searchFiles({commit, state}, data) {
      return listItems(data)
        .then(({result, pagination}) => {
          commit('setSearchFiles', result)
          commit('setSearchPagination', pagination)
          return {result, pagination}
        })
    },
    searchSnapshotDetails({commit, state}, data) {
      return listItems(data)
        .then(({result, pagination}) => {
          commit('setSearchFiles', result)
          commit('setSearchPagination', pagination)
          return {result, pagination}
        })
    },
    listBreadcrumps({state, commit}, {userId, snapshotDate}) {
      if (state.folderId && userId && snapshotDate) {
        return listChatBreadcrumps({
          userId,
          snapshotDate,
          folderId: state.folderId
        })
          .then(result => {
            commit('setBreadcrumps', result);
          })
      } else {
        commit('setBreadcrumps', []);
        return Promise.resolve();
      }
    },
    exportSnapshot({commit}, data) {
      return exportSnapshot(data);
    },
    restoreSnapshot({commit}, data) {
      return restoreSnapshot(data);
    },
    listInitialBackupStats({commit, state}, filter) {
      return listInitialBackupStats({
        ...state.filterBackupStatus,
        id: filter.id,
      })
        .then((result) => {
          commit('setInitialBackupStatus', result)
          return result;
        })
    },
  },

  mutations: {
    setFiles(state, files) {
      const existingIds = new Set(state.files.map(f => f.id));
      const filteredNewFiles = files.filter(f => !existingIds.has(f.id));
      state.files = [...state.files, ...filteredNewFiles];
    },
    resetFiles(state) {
      state.files = [];
    },
    resetFilesPagination(state) {
      state.paginationChatUsers = {
        ...defaultPagination(),
        pageSize: 20
      };
    },
    setMessages(state, messages) {
      const existingIds = new Set(state.messages.map(f => f.id));
      const filteredNewMessages = messages.filter(f => !existingIds.has(f.id));
      state.messages = [...state.messages, ...filteredNewMessages];
    },
    resetMessages(state) {
      state.messages = [];
    },
    resetMessagesPagination(state) {
      state.paginationChatMessages = {
        ...defaultPagination(),
        pageSize: 20,
        sortBy: 'snapshots.chat_message.created_date_time',
        sortDescending: true
      };
    },
    setPaginationChatUsers(state, pagination) {
      state.paginationChatUsers = pagination;
    },
    setPaginationChatMessages(state, pagination) {
      state.paginationChatMessages = pagination;
    },
    setSearchFiles(state, files) {
      state.searchFiles = files;
    },
    setSearchPagination(state, pagination) {
      state.searchPagination = pagination;
    },
    resetSearchPagination(state) {
      state.searchPagination = {
        ...defaultPagination(),
        sortBy: 'snapshots.event.start.date_time'
      };
    },
    setFolderId(state, folderId) {
      state.folderId = folderId;
    },
    setSearch(state, search) {
      state.search = search;
    },
    setBreadcrumps(state, breadcrumps) {
      state.breadcrumps = breadcrumps;
    },
    setInitialSearch(state, initialSearch) {
      state.initialSearch = initialSearch
    },
    resetState(state) {
      // Breadcrumb navigation resets the chat view, but the backup status
      // must remain available to keep recovery actions gated correctly.
      const {initialBackupStatus} = state;
      Object.assign(state, defaultState(), {initialBackupStatus})
    },
    setInitialBackupStatus(state, initialBackupStatus) {
      state.initialBackupStatus = initialBackupStatus
    },
  },

  state: defaultState
}
